export async function parseJSON(called_by: string, response: Response) {
  let rawData = '';
  let data;
  try {
    rawData = await response.text();
    data = JSON.parse(rawData);
  } catch {
    const message = `[${called_by}] Erro ao processar a resposta da API. JSON inválido: ${rawData}`;
    console.warn(message);
    throw new Error(message);
  }
  return data;
}
